import React, { createContext, ReactNode, useState } from "react"
import { useLocation } from "react-router-dom"

interface IContextDefault {
  showAbstractFeatures: boolean
  setShowAbstractFeatures: (val: boolean) => void
  elementDetails: any
  setElementDetails: (value: any) => void
  typeDisplayName: string
  setTypeDisplayName: (value: string) => void
  atId: number | null
  setAtId: (value: number | null) => void
  loading: boolean
  setLoading: (value: boolean) => void
  updateHistory: (history: any, catalog: string, type: string, typeId: string) => void
}

export enum clickedElementEnum {
  featureType,
  featureTypeGroup,
  attributeType,
  none
}

export const FeatureCatalogContext = createContext<IContextDefault>({} as IContextDefault)

const FeatureCatalogProvider = (props: { children?: ReactNode }) => {
  const [showAbstractFeatures, setShowAbstractFeatures] = useState(false)
  const [elementDetails, setElementDetails] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [typeDisplayName, setTypeDisplayName] = useState<string>("")
  const [atId, setAtId] = useState<number | null>(null)
  const { search } = useLocation()

  const updateHistory = (history: any, catalog: string, type: string, typeId: string) => {
    const address = `/featurecatalogdetails/${catalog}/${type}/${typeId}`
    if (history.location.state === catalog) {
      // If there is no type in history yet, the state needs to be pushed, not replaced.
      history.push({ pathname: address, state: type + "/" + typeId, search: "?" + new URLSearchParams(search) })
    } else {
      history.replace({ pathname: address, state: type + "/" + typeId, search: "?" + new URLSearchParams(search) })
    }
  }

  return (
    <FeatureCatalogContext.Provider
      value={{
        showAbstractFeatures,
        setShowAbstractFeatures,
        typeDisplayName,
        setTypeDisplayName,
        elementDetails,
        setElementDetails,
        atId,
        setAtId,
        loading,
        setLoading,
        updateHistory
      }}
    >
      {props.children}
    </FeatureCatalogContext.Provider>
  )
}

export default FeatureCatalogProvider
